import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { EventItem } from "core/http/service/internalEvents/types";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: EventItem;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {
    name: "",
    description: "",
    endTime: "",
    startTime: "",
    status: "",
    thumb: "",
  },
};

const getDetailEventSlice = createSlice({
  name: "getDetailEvent",
  initialState,
  reducers: {
    getDetailEventStart: (
      state,
      action: PayloadAction<{ eventId: string }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getDetailEventSuccess: (
      state,
      action: PayloadAction<{
        data: EventItem;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload.data;
    },
    getDetailEventFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = initialState.data;
    },
    resetDetailEvent: () => initialState,
  },
});

export const {
  getDetailEventStart,
  getDetailEventSuccess,
  getDetailEventFailed,
  resetDetailEvent,
} = getDetailEventSlice.actions;

export default getDetailEventSlice.reducer;
